import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { ratioKeys } from "./query-keys";

export function useRatioPolicy(sku: string, enabled = true) {
  return useQuery({
    queryKey: ratioKeys.detail(sku),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/inventory-ratio/{sku}", {
        params: { path: { sku } },
      });
      if (error) throw error;
      return data;
    },
    enabled,
    staleTime: 30_000,
  });
}
